module.exports = __webpack_public_path__ + "bw.svg?5e96c2532be7960e07b4fbb0d854372b";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/bw.svg
// module id = 1210
// module chunks = 27